export enum PosterCode {
    webHor = 1,
    webVer = 2,
    webMain = 3,
    mobileHor = 4,
    mobileVer = 5,
    mobileMain = 6,
    tvHor = 7,
    tvVer = 8,
    tvMain = 9
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/enums/poster-code.enum.ts